<template>
  <div class="collect-school">
    <div class="title"><i class="el-icon-edit-outline"></i> 我收藏的院校专业组</div>
    <div class="collect-panel">
      <div class="create-compare">
        <el-button
          @click="deleteAllCollege"
          type="primary"
          icon="el-icon-delete"
          plain
          >删除全部院校</el-button
        >
        <el-button
          type="primary"
          icon="el-icon-folder"
          @click="openAllMnzyb"
          plain>已保存的志愿方案</el-button>
        <el-button
          type="success"
          icon="el-icon-folder"
          @click="saveDialogHandle"
          plain>保存</el-button>
        <el-button
          @click="getCompareData2"
          type="success"
          icon="el-icon-document"
          plain
          >生成模拟方案表</el-button
        >
      </div>

      <div class="collect-title" style="border-top:1px solid #1f4778;
        border-bottom:1px solid #1f4778;margin: 20px 0;padding: 10px 0;width: 880px;
        justify-content: space-between;display:flex;">
            <div style="width:400px;margin-left: 20px;">文件名：<span>{{planObj.plan}}</span></div>
            <div style="width:200px;">时间：<span>{{planObj.time}}</span></div>
      </div>

      <!-- style="100%" -->
       <!-- 
                <router-link
                  tag="a"
                  target="_blank"
                  :to="{
                    path: '/main/schoolDetail' + '/me',
                    query: { item: scope.row.gb, zyz:scope.row.zyz }
                  }"
                >
                  <el-button size="mini">查看</el-button>
                </router-link> 
                
                <router-link
                  tag="a"
                  target="_blank"
                  :to="{
                    path: '/main/schoolDetail' + '/me',
                    query: { item: scope.row.gb, zyz:scope.row.zyz }
                  }"
                >
                  <el-button size="mini">查看</el-button>
                </router-link>
                
              <el-button size="mini" type="primary"
              @click="chooseZy(scope.row)">选择专业</el-button>
                -->
       <div ref="collectSchoolRef1">
          <el-tabs v-model="tabPc" type="card">
            <el-tab-pane label="本科提前批" name="0">
              <div class="page-scroll">
              </div>
                <el-table
                border
                :data="collectSchool.bkZyzRecords"
                size="small"
                :row-key="getRowKeys"
                @selection-change="handleSelectionChange"
                style="width:100%;"
                max-height="460"
                :span-method="objectSpanMethod"
              >
                <el-table-column
                  type="selection"
                  width="40"
                  align="center"
                  reserve-selection
                ></el-table-column>
                <el-table-column  prop="sb" label="院校代码" show-overflow-tooltip
                width="50" align="center">
                    <!-- <div style="display:flex;justify-content:center;">
                      <el-button type="primary" size="small" style="width:50px;
                      display:flex;justify-content:center;">{{scope.row.sb}}</el-button>
                    </div> -->
                  <!-- <template slot-scope="scope">
                    <div>
                        <a-popover 
                                placement="bottomLeft"
                                trigger="click"
                                :visible="scope.row.inputSbVisible"
                                @visibleChange="clickShowInputSbPopover($event,scope.row)">
                            <div style="display: flex;align-items: center;" slot="content">
                                <el-input style="width: 80px;" type="number"
                                v-model="scope.row.writeSb" size="mini"
                                @input="changeTabSb($event,scope.row)"
                                @change="setSbNoSave($event,scope.row)"></el-input>
                                <div>
                                    <el-button type="primary" size="small"
                                    style="margin-left: 6px;" @click="submitUpdateSb(scope.row)">确定</el-button>
                                </div>
                            </div>
                                <el-button type="primary" size="mini"
                                     style="width: 40px;display: flex;justify-content: center;
                                     text-overflow:ellipsis;overflow: hidden;white-space: nowrap;"
                                    >
                                    {{ scope.row.submitSb?scope.row.submitSb+'(未保存)'
                                    :scope.row.submitSb||scope.row.sb }}
                                </el-button>
                            </a-popover>
                    </div>
                  </template> -->
                </el-table-column>
                <el-table-column  prop="yxmc" label="院校名称"
                show-overflow-tooltip
                width="160" align="center">
                  <template slot-scope="scope">
                    <router-link
                          tag="a"
                          target="_blank"
                          :to="{
                            path: '/main/schoolDetail' + '/me',
                            query: { item: scope.row.gb, zyz:scope.row.zyz,pc:scope.row.pc }
                          }"
                        >
                          <span>{{ scope.row.yxmc }}</span>
                    </router-link>
                    <!-- <el-button size="small" type="primary">{{ scope.row.yxmc }}</el-button> -->
                  </template>
                </el-table-column>
                <el-table-column  prop="zyz" label="专业组" show-overflow-tooltip
                width="50" align="center">
                  <!-- <template slot-scope="scope">
                    <div style="display:flex;justify-content:center;">
                    <el-button size="small" type="primary">{{ scope.row.zyz }}</el-button>
                    </div>
                  </template> -->
                </el-table-column>
                <!-- <el-table-column  prop="zylb" label="专业类别" show-overflow-tooltip 
                  align="center" width="80"> </el-table-column> -->
                <el-table-column label="开设专业"
                show-overflow-tooltip width="90"
                  align="center">
                  <template slot-scope="scope">
                    <div v-if="scope.row.chooseFlag"
                    style="display:flex;flex-direction:column;
                    justify-content:flex-start;">            
                      <el-button type="primary" size="mini"
                        style="background-color: #ff861a;border: 1px solid white;
                        display:flex;justify-content:center;"
                          @click="chooseZy(scope.row)">选择专业</el-button>
                        <el-button
                          @click="handleDelete(scope.row)"
                          type="danger"
                          size="mini"
                          style="margin-top:10px;margin-left:0 !important;"
                          >删除</el-button>
                      </div>
                        <div v-else style="display:flex;flex-direction:column;
                        justify-content:flex-start;">
                          <el-button  type="primary" size="mini"
                            style="display:flex;justify-content:center;"
                            @click="chooseZy(scope.row)">选择专业</el-button>
                          <el-button
                            @click="handleDelete(scope.row)"
                            type="danger"
                            size="mini"
                            style="margin-top:10px;margin-left:0 !important;"
                            >删除</el-button
                          >
                        </div>
                  </template>  
                </el-table-column>
                <el-table-column  prop="yxdq" label="所在地区"
                show-overflow-tooltip align="center" width="50" > </el-table-column>
                <el-table-column  prop="nd" label="年度"
                show-overflow-tooltip align="center" width="50" > </el-table-column>
                <el-table-column  label="综合成绩" show-overflow-tooltip
                align="center" >
                  <el-table-column  label="最低" prop="lowestScore" width="60"
                  show-overflow-tooltip align="center">
                  </el-table-column>
                  <el-table-column  label="平均" prop="pjzhcj" width="50"
                  show-overflow-tooltip align="center"></el-table-column>
                  <el-table-column  label="最高" prop="zgzhcj" width="50"
                  show-overflow-tooltip align="center"></el-table-column>
                </el-table-column>
                <el-table-column  prop="zhcj" label="我的综合成绩"
                show-overflow-tooltip align="center" width="50" > </el-table-column>
                <el-table-column  label="招生计划" show-overflow-tooltip
                align="center" >
                  <el-table-column  label="往年" prop="currentPlan" width="50"
                  show-overflow-tooltip align="center"></el-table-column>
                  <el-table-column  label="今年" prop="thisPlan" width="50"
                  show-overflow-tooltip align="center"></el-table-column>
                </el-table-column>
                <el-table-column  label="是否服从" prop="sffc"
                show-overflow-tooltip align="center" width="50" >
                <template>
                  <span>服从</span>
                </template>
                </el-table-column>
                <!-- <el-table-column  label="操作" width="70"
                  align="center" show-overflow-tooltip>
                  <template slot-scope="scope">
                    <div>
                      <el-button
                        @click="handleDelete(scope.row)"
                        type="danger"
                        size="mini"
                        >删除</el-button
                      >
                    </div>
                  </template>
                </el-table-column> -->
                </el-table>
            </el-tab-pane>
            <el-tab-pane label="高职高专批" name="7">
              <el-table
              border
              :data="collectSchool.zkZyzRecords"
              size="small"
              :row-key="getRowKeys2"
              @selection-change="handleSelectionChange2"
                style="width:100%;"
                max-height="460"
                :span-method="objectSpanMethod2"
            >
                <el-table-column
                  type="selection"
                  width="40"
                  align="center"
                  reserve-selection
                ></el-table-column>
                <el-table-column fixed prop="sb" label="院校代码" show-overflow-tooltip
                width="50" align="center"> </el-table-column>
                <el-table-column fixed prop="yxmc" label="院校名称"
                show-overflow-tooltip
                width="160" align="center">
                  <template slot-scope="scope">
                    <router-link
                          tag="a"
                          target="_blank"
                          :to="{
                            path: '/main/schoolDetail' + '/me',
                            query: { item: scope.row.gb, zyz:scope.row.zyz,pc:scope.row.pc }
                          }"
                        >
                          <span>{{ scope.row.yxmc }}</span>
                    </router-link>
                  </template>
                </el-table-column>
                <el-table-column fixed prop="zyz" label="专业组" show-overflow-tooltip
                width="50" align="center"> </el-table-column>
                <!-- <el-table-column fixed prop="zylb" label="专业类别" show-overflow-tooltip 
                  align="center" width="80"> </el-table-column> -->
                <el-table-column label="开设专业"
                show-overflow-tooltip width="90"
                  align="center">
                  <template slot-scope="scope">
                    <div v-if="scope.row.chooseFlag"
                    style="display:flex;flex-direction:column;
                    justify-content:flex-start;">            
                      <el-button type="primary" size="mini"
                        style="background-color: #ff861a;border: 1px solid white;
                        display:flex;justify-content:center;"
                          @click="chooseZy(scope.row)">选择专业</el-button>
                        <el-button
                          @click="handleDelete(scope.row)"
                          type="danger"
                          size="mini"
                          style="margin-top:10px;margin-left:0 !important;"
                          >删除</el-button>
                      </div>
                        <div v-else style="display:flex;flex-direction:column;
                        justify-content:flex-start;">
                          <el-button  type="primary" size="mini"
                            style="display:flex;justify-content:center;"
                            @click="chooseZy(scope.row)">选择专业</el-button>
                          <el-button
                            @click="handleDelete(scope.row)"
                            type="danger"
                            size="mini"
                            style="margin-top:10px;margin-left:0 !important;"
                            >删除</el-button
                          >
                        </div>
                  </template>  
                </el-table-column>
                <el-table-column  prop="yxdq" label="所在地区"
                show-overflow-tooltip align="center" width="50" > </el-table-column>
                <el-table-column  prop="nd" label="年度"
                show-overflow-tooltip align="center" width="50" > </el-table-column>
                <el-table-column  label="综合成绩" show-overflow-tooltip
                align="center" >
                  <el-table-column  label="最低" prop="lowestScore" width="60"
                  show-overflow-tooltip align="center">
                  </el-table-column>
                  <el-table-column  label="平均" prop="pjzhcj" width="50"
                  show-overflow-tooltip align="center"></el-table-column>
                  <el-table-column  label="最高" prop="zgzhcj" width="50"
                  show-overflow-tooltip align="center"></el-table-column>
                </el-table-column>
                <el-table-column  prop="zhcj" label="我的综合成绩"
                show-overflow-tooltip align="center" width="50" > </el-table-column>
                <el-table-column  label="招生计划" show-overflow-tooltip
                align="center" >
                  <el-table-column  label="往年" prop="currentPlan" width="50"
                  show-overflow-tooltip align="center"></el-table-column>
                  <el-table-column  label="今年" prop="thisPlan" width="50"
                  show-overflow-tooltip align="center"></el-table-column>
                </el-table-column>
                <el-table-column  label="是否服从" prop="sffc"
                show-overflow-tooltip align="center" width="50" >
                <template>
                  <span>服从</span>
                </template>
                </el-table-column>
                <!-- <el-table-column label="操作" width="70"
                  align="center" show-overflow-tooltip>
                  <template slot-scope="scope">
                    <div>
                      <el-button
                        @click="handleDelete(scope.row)"
                        type="danger"
                        size="mini"
                        >删除</el-button
                      >
                    </div>
                  </template>
                </el-table-column> -->
              </el-table>
            </el-tab-pane>
          </el-tabs>

      
          <!-- <el-table
          border
          :data="collectSchool.bkZyzRecords"
          size="small"
          :row-key="getRowKeys"
          @selection-change="handleSelectionChange"
        >
          <el-table-column
            type="selection"
            width="55"
            align="center"
            reserve-selection
          ></el-table-column>
          <el-table-column fixed prop="sb" label="院校代码" show-overflow-tooltip
          width="70" align="center"> </el-table-column>
          <el-table-column fixed prop="yxmc" label="院校名称" show-overflow-tooltip
          width="120" align="center"> </el-table-column>
          <el-table-column fixed prop="zyz" label="专业组" show-overflow-tooltip
          width="60" align="center"> </el-table-column>
          <el-table-column fixed prop="zylb" label="专业类别" show-overflow-tooltip 
            align="center"> </el-table-column>
          <el-table-column fixed prop="yxdq" label="所在地区" show-overflow-tooltip
          align="center" width="80" > </el-table-column>
          <el-table-column fixed prop="date" label="操作" width="150"
            align="center">
            <template slot-scope="scope">
              <div>
                <router-link
                  tag="a"
                  target="_blank"
                  :to="{
                    path: '/main/schoolDetail' + '/me',
                    query: { item: scope.row.gb, zyz:scope.row.zyz }
                  }"
                >
                  <el-button size="mini">查看</el-button>
                </router-link>
                <el-button
                  @click="handleDelete(scope.row)"
                  type="danger"
                  size="mini"
                  >删除</el-button
                >
              </div>
            </template>
          </el-table-column>
          </el-table> -->
       </div>

       <!-- 60% -->
      <el-dialog 
        :title="collegesTabName" :visible.sync="dialogTableVisible" width="90%" center>
        <div id="yxsTab">
          <compare-table
            :colleges="colleges"
            @download="download2"
            @sortData2="sortData2"
            @sortData3="sortData3"
          />
        </div>
      </el-dialog>

      <el-dialog title="已保存的志愿方案列表" :visible.sync="dialogPlanTabVisible"
      width="60%">
        <div style="margin-bottom: 20px;">
                <el-button type="primary" @click="allDialogChecked">全选</el-button>
                <el-button type="primary" @click="allDialogNoChecked">取消全选</el-button>
                <el-button type="primary" @click="deleteDialogChecked">删除</el-button>
        </div>
        <el-table :data="planList" border size="small"
          :header-cell-style="{'background-color':'#5287c6','border': '1px solid #1f4778'
           ,'color': '#FFF','text-align':'center'}"
          :cell-style="{'border': '1px solid #1f4778','text-align':'center'}">
          <el-table-column show-overflow-tooltip prop="checked" width="60" label="选择">
            <template slot-scope="scope">
               <el-checkbox v-model="scope.row.checked" @change="planCheckChange"></el-checkbox>
            </template>
          </el-table-column>
          <el-table-column label="序号" show-overflow-tooltip :resizable="false"
          type="index"></el-table-column>
          <el-table-column label="方案名称" prop="name"
          show-overflow-tooltip :resizable="false"></el-table-column>
          <el-table-column label="专业类别" prop="lb"
          show-overflow-tooltip :resizable="false"></el-table-column>
          <el-table-column label="保存时间" prop="updateTime"
          show-overflow-tooltip :resizable="false"></el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button type="primary" size="small" @click="openMnzyb(scope.row)">修改</el-button>
              <el-button type="primary" size="small"
              @click="delMnzybById(scope.row.id)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-dialog>

      <el-dialog title="请选择要替换的方案" :visible.sync="dialogSavePlanVisible"
        width="20%" center>
        <div style="margin:0 20px;">
          <el-select size="small" v-model="selectedPlanValue">
            <el-option v-for="(item,index) in planList" :key="index"
            :label="item.name" :value="item.id"></el-option>
          </el-select>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button type="primary" size="small" @click="saveMnzyb">确定</el-button>
          <el-button size="small" @click="saveOtherDialogHandle">另存为</el-button>
        </div>
      </el-dialog>

      <el-dialog title="请输入方案名" :visible.sync="dialogSaveInputVisible"
      width="20%"
      center >
        <el-input size="small" v-model="otherPlanName"></el-input>
        <div slot="footer" class="dialog-footer">
          <el-button type="primary" size="small" @click="saveOtherMnzyb">确定</el-button>
          <el-button size="small" @click="cancelHideDialog">取消</el-button>
        </div>
      </el-dialog>

      <el-dialog title="选择专业" :visible.sync="dialogZyChooseVisible"
      width="60%" :destroy-on-close="true" @opened="openChooseZy">
      <div style="margin:0 20px;">
                <xp-transfer :left-columns="leftColumns" :left-data="filterZyDataLeft"
                :left-expanded-row-keys="expandedRowKeys" :left-select-rows="leftSelectRows"
                :left-row-selection="aRowSelection" :left-tab-row-class-name="aTabRowClassName"
                :left-top-title="leftTopTitle" :left-custom-row="aCustomRow.customRow"
                :right-columns="rightColumns" :right-data="filterZyData" :right-custom-row="bCustomRow.customRow"
                :right-expanded-row-keys="expandedRowKeys2" :right-row-selection="aRowSelection2"
                :right-select-rows="rightSelectRows" :right-top-title="rightTopTitle"
                @leftTabChange="leftTabChange" @rightTabChange="rightTabChange" @addRightZy="addRightZy"
                @addLeftZy="addLeftZy"
                >
                        
                        <div class="h" slot="left-header"
                        style="padding: 9px 12px 9px 19px;border-bottom: 1px solid #e8e8e8;margin-bottom: 4px;">
                                <div>
                                    <span style="color: blue;font-weight: 700;">{{searchYxmc}}</span>
                                        {{searchZyz}}组共{{zyData.length}}个专业
                                </div>
                                <div></div>
                        </div>
                        <div class="h" slot="right-header"
                        style="padding: 9px 12px 9px 19px;border-bottom: 1px solid #e8e8e8;margin-bottom: 4px;">
                                <div>
                                    已选择
                                    <span style="color: blue;font-weight: 700;">{{ selectedZys.length }}</span>个专业填报
                                </div>
                                <div></div>
                        </div>
                        <div slot="footer" class="f" style="border-top:1px solid #e8e8e8;padding: 6px 10px;">
                                <el-button size="small" @click="moveUp2">上移</el-button>
                                <el-button size="small" @click="moveDown2">下移</el-button>
                        </div>
                </xp-transfer>
      </div>
            <div style="width:200px;margin:0 auto;margin-top:20px;">
                <el-button type="primary" @click="saveCheckedZy">保存</el-button>
                <el-button @click="closeZyDialog">取消</el-button>
            </div>
      </el-dialog>
    </div>
    <div class="pagination" v-if="collectSchool.records"  ref="collectSchoolRef2">
      <el-pagination
        background
        layout="prev, pager, next,total"
        prev-text="上一页"
        next-text="下一页"
        v-if="tabPc=='0'"
        :current-page="collectSchool.bkPageNum"
        :total="collectSchool.bkTotal"
        :page-size="collectSchool.bkSize"
        @current-change="handleClickPage"
      >
      </el-pagination>
      <el-pagination
        background
        layout="prev, pager, next,total"
        prev-text="上一页"
        next-text="下一页"
        v-else-if="tabPc=='7'"
        :current-page="collectSchool.zkPageNum"
        :total="collectSchool.zkTotal"
        :page-size="collectSchool.zkSize"
        @current-change="handleClickPage"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
import { getSchoolDetail } from "@/api/index";
import { createCompareData, downloadTable } from "../../../api/newExam";
import { mapState } from "vuex";
import CompareTable from "../../../components/ysh/ZyzCompareTable.vue";
import axios from "../../../api/http";
import XpTransfer from '../../../components/xpTransfer.vue';
import {MessageBox} from 'element-ui';
export default {
  name: "CollectSchool",
  components: {
    CompareTable,
    XpTransfer
  },
  data() {
    return {
      pageNum: 1,
      dialogTableVisible: false,
      multipleSelection: [], // 选中要对比的数据
      multipleSelection2: [], // 专科选中要对比的数据
      module:{},
      collegesTabName:'年湖南普通高校招生我的高考志愿方案',
      colleges: [], // 要生成对比表格的数据
      planList:[],
      dialogPlanTabVisible:false,
      dialogSavePlanVisible:false,
      dialogSaveInputVisible:false,
      dialogZyChooseVisible:false,
      leftColumns:[
            {
                            dataIndex: 'title',
                            title: '专业',
                            ellipsis:true,
                            width:140,
                            align:'left'
            },
            {
                            dataIndex: 'xf',
                            title: '学费',
                            align:'left'
            },
      ],
      rightColumns:[
            {
                            dataIndex: 'xh',
                            title: '序号',
                            ellipsis:true,
                            width:50,
                            align:'center'
            },
            {
                            dataIndex: 'title',
                            title: '专业',
                            ellipsis:true,
                            width:110,
                            align:'left'
            },
            {
                            dataIndex: 'xf',
                            title: '学费',
                            align:'left'
            },
      ],
      filterZyData:[],
      filterZyDataLeft:[],
      expandedRowKeys:[],
      expandedRowKeys2:[],
      leftSelectRows:[],
      rightSelectRows:[],
      leftTopTitle:"",
      rightTopTitle:"",
      aCustomRow:{
            customRow:(record)=>{
                const that=this;
                                        return {
                                                props: {
                                                },
                                                on: { // 事件
                                                    click: (event) => {
                                                        if(record.isDisabled){
                                                            return;
                                                        }
                                                        const leftArr=that.filterZyDataLeft;
                                                        for(let i=0;i<leftArr.length;i++){
                                                            if(record.key===leftArr[i].key){
                                                                leftArr[i].isChecked=!leftArr[i].isChecked;
                                                                break;
                                                            }
                                                        }
                                                        that.filterZyDataLeft=leftArr;
                                                        if(that.leftSelectRows.indexOf(record.key)>=0){
                                                            that.leftSelectRows.splice(that.leftSelectRows.indexOf(record.key),1);
                                                        }else{
                                                            that.leftSelectRows.push(record.key);
                                                        }
                                                        if(that.leftSelectRows.length>0){
                                                            that.$message({
                                                                message:"已选择"+that.leftSelectRows.length+"所院校",
                                                                type:"success",
                                                                showClose:true
                                                            });
                                                        }
                                                        const selectedRows=that.leftSelectRows;
                                                        console.log(selectedRows.length);
                                                        if(selectedRows.length===6){
                                                            this.filterZyDataLeft.forEach((item,index)=>{
                                                                for(let i=0;i<selectedRows.length;i++){
                                                                    if(item.key!==selectedRows[i]&&item.key!==record.key){
                                                                        if(item.isChecked&&selectedRows.indexOf(item.key)>=0){
                                                                            item.isDisabled=false;
                                                                        }else if(item.isChecked&&selectedRows.indexOf(item.key)===-1){
                                                                            item.isChecked=false;
                                                                            item.isDisabled=true;
                                                                        }else{
                                                                            item.isDisabled=true;
                                                                        }
                                                                    }else{
                                                                        item.isChecked=true;
                                                                        item.isDisabled=false;
                                                                    }
                                                                }
                                                            });
                                                        }else{
                                                            that.filterZyDataLeft.forEach((item,index)=>{
                                                                item.isDisabled=false;
                                                            });
                                                        }
                                                        that.filterZyDataLeft=[...that.filterZyDataLeft];
                                                        that.leftSelectRows=[...that.leftSelectRows];
                                                        console.log(record,leftArr);
                                                    },       // 点击行
                                                    dblclick: (event) => {},
                                                    contextmenu: (event) => {},
                                                    mouseenter: (event) => {},  // 鼠标移入行
                                                    mouseleave: (event) => {}
                                                },

                                                };
                        },
      },
      bCustomRow:{
            customRow:(record)=>{
                const that=this;
                                        return {
                                                props: {
                                                },
                                                on: { // 事件
                                                    click: (event) => {
                                                        if(record.isDisabled){
                                                            return;
                                                        }
                                                        const leftArr=that.filterZyData;
                                                        for(let i=0;i<leftArr.length;i++){
                                                            if(record.key===leftArr[i].key){
                                                                leftArr[i].isChecked=!leftArr[i].isChecked;
                                                                break;
                                                            }
                                                        }
                                                        that.filterZyData=leftArr;
                                                        if(that.rightSelectRows.indexOf(record.key)>=0){
                                                            that.rightSelectRows.splice(that.rightSelectRows.indexOf(record.key),1);
                                                        }else{
                                                            that.rightSelectRows.push(record.key);
                                                        }
                                                        if(that.rightSelectRows.length>0){
                                                            that.$message({
                                                                message:"已选择"+that.rightSelectRows.length+"所院校",
                                                                type:"success",
                                                                showClose:true
                                                            });
                                                        }
                                                        const selectedRows=that.rightSelectRows;
                                                        console.log(selectedRows.length);
                                                        if(selectedRows.length===6){
                                                            this.filterZyData.forEach((item,index)=>{
                                                                for(let i=0;i<selectedRows.length;i++){
                                                                    if(item.key!==selectedRows[i]&&item.key!==record.key){
                                                                        if(item.isChecked&&selectedRows.indexOf(item.key)>=0){
                                                                            item.isDisabled=false;
                                                                        }else if(item.isChecked&&selectedRows.indexOf(item.key)===-1){
                                                                            item.isChecked=false;
                                                                            item.isDisabled=true;
                                                                        }else{
                                                                            item.isDisabled=true;
                                                                        }
                                                                    }else{
                                                                        item.isChecked=true;
                                                                        item.isDisabled=false;
                                                                    }
                                                                }
                                                            });
                                                        }else{
                                                            that.filterZyData.forEach((item,index)=>{
                                                                item.isDisabled=false;
                                                            });
                                                        }
                                                        that.filterZyData=[...that.filterZyData];
                                                        that.rightSelectRows=[...that.rightSelectRows];
                                                        console.log(record,leftArr);
                                                    },       // 点击行
                                                    dblclick: (event) => {},
                                                    contextmenu: (event) => {},
                                                    mouseenter: (event) => {},  // 鼠标移入行
                                                    mouseleave: (event) => {}
                                                },

                                                };
                        },
      },
      selectedPlanValue:'',
      zyData:[],
      searchZyz:'',
      searchYxmc:'',
      selectedZys:[],
      tabPc:'0',
      otherPlanName:'',
      planObj:{
        name:'',
        time:''
      }
    };
  },
  computed: {
    ...mapState(["userInfo", "collectSchool","ysCollectInfo"]),
        aRowSelection(){
            return {
                type:"checkbox",
                selectedRowKeys:this.leftSelectRows,
                getCheckboxProps:record=>({
                    props:{
                        checked:record.isChecked,
                        disabled:record.isDisabled,
                        key:record.key
                    }
                }),
                onChange: (selectedRowKeys, selectedRows) => {
                    this.leftSelectRows=selectedRowKeys;
                    console.log(`selectedRowKeys: ${selectedRowKeys}`, 'selectedRows: ', selectedRows);
                },
                onSelect: (record, selected, selectedRows) => {
                    if(selectedRows.length>0){
                        this.$message({
                            message:"已经选中了"+selectedRows.length+"个专业",
                            type:'success',
                            showClose:true
                        });
                    }
                    if(selectedRows.length===6){
                        this.filterZyDataLeft.forEach(item=>{
                            const leftSelected=this.leftSelectRows;
                            for(let i=0;i<leftSelected.length;i++){
                                console.log(item,leftSelected[i]);
                                if(item.key===leftSelected[i]){
                                    item.isDisabled=false;
                                    item.isChecked=true;
                                }else if(item.key!==leftSelected[i]&&item.isChecked===true){
                                    let flag=false;
                                    for(let j=0;j<selectedRows.length;j++){
                                        if(selectedRows[j].key===item.key){
                                            flag=true;
                                            break;
                                        }
                                    }
                                    if(flag){
                                        item.isDisabled=false;
                                    }else{
                                        item.isDisabled=true;
                                    }
                                }else{
                                    item.isDisabled=true;
                                }
                            }
                        });
                        this.filterZyDataLeft=[...this.filterZyDataLeft];
                    }else{
                        this.filterZyDataLeft.forEach(item=>{
                            item.isDisabled=false;
                        });
                        this.filterZyDataLeft=[...this.filterZyDataLeft];
                    }
                    console.log(record, selected, selectedRows);
                },
                onSelectAll: (selected, selectedRows, changeRows) => {
                    if(selectedRows.length>0){
                        this.$message({
                            message:"已经选中了"+selectedRows.length+"个专业",
                            type:'success',
                            showClose:true
                        });
                    }else{
                        this.filterZyDataLeft.forEach(item=>{
                            if(item){
                                item.isDisabled=false;
                            }
                        });
                        this.filterZyDataLeft=[...this.filterZyDataLeft];
                    }
                    console.log(selected, selectedRows, changeRows);
                },
            }
        },
        aRowSelection2(){
            return {
                type:"checkbox",
                selectedRowKeys:this.rightSelectRows,
                getCheckboxProps:record=>({
                    props:{
                        checked:record.isChecked,
                        disabled:record.isDisabled,
                        key:record.key
                    }
                }),
                onChange: (selectedRowKeys, selectedRows) => {
                    this.rightSelectRows=selectedRowKeys;
                    console.log(`selectedRowKeys: ${selectedRowKeys}`, 'selectedRows: ', selectedRows);
                },
                onSelect: (record, selected, selectedRows) => {
                    this.$message({
                        message:"已经选中了"+selectedRows.length+"个专业",
                        type:'success',
                        showClose:true
                    });
                    console.log(record, selected, selectedRows);
                },
                onSelectAll: (selected, selectedRows, changeRows) => {
                    this.$message({
                        message:"已经选中了"+selectedRows.length+"个专业",
                        type:'success',
                        showClose:true
                    });
                    console.log(selected, selectedRows, changeRows);
                },
            }
        },
  },
  methods: {
    // 删除收藏的院校专业组
    async handleDelete(row) {
      if(!this.planObj.plan){
        await this.$store.dispatch("removeCollectSchoolZyz", {
          uid: this.userInfo.yhid,
          collegeid: (row.gb||row.gbdm),
          zyz:row.zyz,
          pc:row.pc,
          deleteRow:row,
          callback: () => {
            if(row.pc==0){
              this.multipleSelection = this.multipleSelection.filter(
                o => o.gb !== row.gb
              );
            }else if(row.pc==7){
              this.multipleSelection2 = this.multipleSelection2.filter(
                o => o.gb !== row.gb
              );
            }
          }
        });
      }else{
        const id=row.id;
        const res=await this.$http.getHttp("/delMnzybDetailById?id="+id);
        if(res.data.code==200){
          if(res.data.message){
            this.$message({
              message:res.data.message,
              type:'success',
              showClose:true
            });
          }else if(res.data.msg){
            this.$message({
              message:res.data.msg,
              type:'success',
              showClose:true
            });
          }else{
            this.$message({
              message:'操作成功',
              type:'success',
              showClose:true
            });
          }
          const { pc ,id}= this.$route.query;
          this.$router.push({
            path:'/main/yshMe/collectZyzSchool',
            query:{
              pc,
              id,
              time:new Date().getTime()}
          });
          location.reload();
        }else if(res.data.code==500){
          if(res.data.message){
            this.$message({
              type:"error",
              message:res.data.message
            });
          }else if(res.data.msg){
            this.$message({
              type:"error",
              message:res.data.msg
            });
          }
        }else if(res.status===401){
              this.$message({message: '登录超时，请重新登录',type:"error"});
              await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
              this.$router.replace({
                  path: '/main/home',
                  query: {redirect: this.$router.currentRoute.fullPath}
              });
        }else if(res.data.code===0){
              this.$message({message:"您的账号在其他地点登陆了！",showClose:true,type:'warning'});
              await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
              this.$router.replace({
                  path: '/main/home',
                  query: {redirect: this.$router.currentRoute.fullPath}
              });
        }else if(res.status===409||res.status===410||res.status===411){
              this.$message({message:"您的账号在其他地点登陆了！",showClose:true,type:'warning'});
              await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
              this.$router.replace({
                  path: '/main/home',
                  query: {redirect: this.$router.currentRoute.fullPath}
              });
        }
      }
    },
    async getApiIndexMethod(){
                const flag=this.$apiFlag;
                if(flag===1||flag===3){
                    this.module=await import("../../../api/newExam");
                }else if(flag===2){
                    this.module=await import("../../../api/newExam11");
                }
    },
    // 批量删除全部院校
    deleteAllCollege(rows) {
      this.$alert("确定要删除所有院校吗？", "提示", {
        confirmButtonText: "确定",
        callback: async (action) => {
          if (action === "confirm") {
            const loading=this.$loading({fullScreen:true,target:this.$refs.collectSchoolRef1,text:'正在操作中'});
            this.$store.commit('initYsCollectInfo');
            const list=this.tabPc=='0'?this.collectSchool.bkZyzRecords:this.tabPc=='7'?this.collectSchool.zkZyzRecords:[];
            await this.$store.dispatch("removeCollegeZyzAll", {
              uid: this.userInfo.yhid,
              list,
              callback: () => {
                this.$message({
                  message: "删除成功",
                  type: "success"
                });
                this.multipleSelection = [];
                this.multipleSelection2 = [];
              }
            });
            loading.close();
          }
        }
      });
    },
    //监听分页按钮
    handleClickPage(pageNum) {
      // this.$store.dispatch("getCollectSchoolZyz", {
      //   uid: this.userInfo.yhid,
      //   pageNum: pageNum
      // });
      this.$store.dispatch("getCollectSchoolZyz", {
        uid: this.userInfo.yhid,
        pageNum: pageNum,
        pc1:0,
        pc2:7
      });
    },
    /** 
     * 1.保留首页或其他选中数据时的选中状态
        问题：el-table 选中状态有分页的情况下，点击分页前一页原本选中状态会被取消
     * 解决：
          1. 在table标签增加属性 :row-key="getRowKeys" 返回值是数据唯一的值
          2. 在type="selection"这一列 开启reserve-selection
    */

    getRowKeys(row) {
      return (row.gb||row.gbdm)+row.zyz+(row.nd||'');
    },
    getRowKeys2(row) {
      return (row.gb||row.gbdm)+row.zyz+(row.nd||'');
    },
    // 保存弹窗显示
    async saveDialogHandle(){
      this.dialogSavePlanVisible=true;
      await this.getMnzybList();
    },
    // 另存为弹窗提示
    saveOtherDialogHandle(){
      this.dialogSaveInputVisible=true;
    },
    // 取消隐藏所有和保存方案相关的弹窗
    cancelHideDialog(){
      this.dialogSavePlanVisible=false;
      this.dialogSaveInputVisible=false;
    },
    // 另存为模拟志愿表方案代码
    async saveOtherMnzyb(){
      const pc=this.tabPc;
      const obj={};
      let Yxs=[];
      if(pc=='0'){
        Yxs=[...this.multipleSelection];
      }else if(pc=='7'){
        Yxs=[...this.multipleSelection2]
      }
      let saveYxs=[];
      for(let i=0;i<Yxs.length;i++){
        if(Yxs[i].yxmc){
          Yxs[i].collegeid=Yxs[i].gb||Yxs[i].gbdm;
          Yxs[i].uid=this.userInfo.yhid;
          Yxs[i].szdq=Yxs[i].yxdq||Yxs[i].szdq;
          // Yxs[i].yhid=this.userInfo.yhid;
          Yxs[i].lb=Yxs[i].zylb;
        }
        const haveFlag=saveYxs.find(item=>{
          return Yxs[i]&&item.yxmc==Yxs[i].yxmc&&item.zyz==Yxs[i].zyz;
        });
        if(!haveFlag){
          saveYxs.push(Yxs[i]);
        }
      }
      obj.list=saveYxs;
      obj.lb=this.userInfo.zylb;
      obj.yhid=this.userInfo.yhid;
      const plan=this.otherPlanName;
      if(!Yxs.length){
        this.$message({
          message:'请选择要保存的学院',
          type:'warning',
          showClose:true
        });
        return;
      }
      if(!plan){
        this.$message({
          message:'请输入方案名',
          type:'warning',
          showClose:true
        });
        return;
      }
      obj.name=plan;
      obj.mnzybId=0;
      obj.pc=parseInt(pc);
      const res=await this.$http.postHttp("/saveMnzyb",obj);
      console.log(res);
      if(res.data.code==200){
        if(res.data.msg){
          this.$message({
            message:res.data.msg,
            type:'success',
            showClose:true
          });
        }else{
          this.$message({
            message:'保存成功',
            type:'success',
            showClose:true
          });
        }
        this.cancelHideDialog();
      }else if(res.data.code==500){
        if(res.data.message){
          this.$message({
            type:"error",
            message:res.data.message
          });
        }else if(res.data.msg){
          this.$message({
            type:"error",
            message:res.data.msg
          });
        }
      }else if(res.status===401){
            this.$message({message: '登录超时，请重新登录',type:"error"});
            await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
            this.$router.replace({
                path: '/main/home',
                query: {redirect: this.$router.currentRoute.fullPath}
            });
      }else if(res.data.code===0){
            this.$message({message:"您的账号在其他地点登陆了！",showClose:true,type:'warning'});
            await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
            this.$router.replace({
                path: '/main/home',
                query: {redirect: this.$router.currentRoute.fullPath}
            });
      }else if(res.status===409||res.status===410||res.status===411){
            this.$message({message:"您的账号在其他地点登陆了！",showClose:true,type:'warning'});
            await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
            this.$router.replace({
                path: '/main/home',
                query: {redirect: this.$router.currentRoute.fullPath}
            });
      }
    },
    // 保存模拟志愿表方案代码（覆盖）
    async saveMnzyb(){
      const pc=this.tabPc;
      const obj={};
      let Yxs=[];
      if(pc=='0'){
        Yxs=[...this.multipleSelection];
      }else if(pc=='7'){
        Yxs=[...this.multipleSelection2]
      }
      let saveYxs=[];
      for(let i=0;i<Yxs.length;i++){
        if(Yxs[i].yxmc){
          Yxs[i].collegeid=Yxs[i].gb||Yxs[i].gbdm;
          // Yxs[i].gbdm=Yxs[i].gb;
          Yxs[i].szdq=Yxs[i].yxdq||Yxs[i].szdq;
          Yxs[i].uid=this.userInfo.yhid;
          Yxs[i].lb=Yxs[i].zylb;
        }
        const haveFlag=saveYxs.find(item=>{
          return Yxs&&Yxs[i].yxmc==item.yxmc&&Yxs[i].zyz==item.zyz;
        });
        if(!haveFlag){
          saveYxs.push(Yxs[i]);
        }
      }
      console.log(saveYxs);
      obj.list=saveYxs;
      obj.lb=this.userInfo.zylb;
      obj.yhid=this.userInfo.yhid;
      obj.pc=parseInt(pc);
      await this.getMnzybList();
      const planList=this.planList;
      const pObj=planList.find(item=>item.id==parseInt(this.selectedPlanValue));
      const plan=pObj&&pObj.name?pObj.name:'';
      if(!Yxs.length){
        this.$message({
          message:'请选择要保存的学院',
          type:'warning',
          showClose:true
        });
        return;
      }
      if(!plan){
        this.$message({
          message:'请选择要替换方案',
          type:'warning',
          showClose:true
        });
        return;
      }
      obj.name=plan;
      obj.mnzybId=parseInt(this.selectedPlanValue||0)
      const res=await this.$http.postHttp("/updateMnzyb",obj);
      if(res.data.code==200){
        if(res.data.msg){
          this.$message({
            message:res.data.msg,
            type:'success',
            showClose:true
          });
        }else{
          this.$message({
            message:'保存成功',
            type:'success',
            showClose:true
          });
        }
        this.cancelHideDialog();
        if(this.planObj.plan){
          const { pc ,id}= this.$route.query;
          this.$router.push({
            path:'/main/yshMe/collectZyzSchool',
            query:{
              pc,
              id,
              time:new Date().getTime()}
          });
          location.reload();
        }
      }else if(res.data.code==500){
        if(res.data.message){
          this.$message({
            type:"error",
            message:res.data.message
          });
        }else if(res.data.msg){
          this.$message({
            type:"error",
            message:res.data.msg
          });
        }
      }else if(res.status===401){
            this.$message({message: '登录超时，请重新登录',type:"error"});
            await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
            this.$router.replace({
                path: '/main/home',
                query: {redirect: this.$router.currentRoute.fullPath}
            });
      }else if(res.data.code===0){
            this.$message({message:"您的账号在其他地点登陆了！",showClose:true,type:'warning'});
            await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
            this.$router.replace({
                path: '/main/home',
                query: {redirect: this.$router.currentRoute.fullPath}
            });
      }else if(res.status===409||res.status===410||res.status===411){
            this.$message({message:"您的账号在其他地点登陆了！",showClose:true,type:'warning'});
            await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
            this.$router.replace({
                path: '/main/home',
                query: {redirect: this.$router.currentRoute.fullPath}
            });
      }
    },
    async openAllMnzyb(){
      await this.getMnzybList();
      this.dialogPlanTabVisible=true;
    },
    // 通过id获取模拟志愿表内容
    async getMnzybById(id){
      const res=await this.$http.getHttp("/getMnzybById?id="+id);
      console.log(res);
      if(res.data.code==200){
        const data={...res.data.data};
        const list=[...data.list];
        const pc=list[0].pc;
        if(pc==0){
          const collectSchool={...this.collectSchool};
          for(let i=0;i<list.length;i++){
            if(list[i].lb){
              list[i].zylb=list[i].lb;
              list[i].yxdq=list[i].szdq;
              for(let j=1;j<7;j++){
                if(list[i]['zydh'+j]){
                  list[i].chooseFlag=true;
                  break;
                }
              }
              list[i].zhcj=this.userInfo.equivalent;
            }
          }
          collectSchool.bkZyzRecords=list;
          collectSchool.zkZyzRecords=[];
          this.$store.commit("userCollectSchool",{collectSchool});
          data.plan=data.name;
          data.time=data.updateTime||data.createTime;
          this.planObj=data;
          this.selectedPlanValue=data.id;
        }else{
          const collectSchool={...this.collectSchool};
          for(let i=0;i<list.length;i++){
            if(list[i].lb){
              list[i].zylb=list[i].lb;
              list[i].yxdq=list[i].szdq;
              for(let j=1;j<7;j++){
                if(list[i]['zydh'+j]){
                  list[i].chooseFlag=true;
                  break;
                }
              }
            }
          }
          collectSchool.bkZyzRecords=[];
          collectSchool.zkZyzRecords=list;
          this.$store.commit("userCollectSchool",{collectSchool});
          data.plan=data.name;
          data.time=data.updateTime||data.createTime;
          this.planObj=data;
          this.selectedPlanValue=data.id;
        }
      }else if(res.data.code==500){
        if(res.data.message){
          this.$message({
            type:"error",
            message:res.data.message
          });
        }else if(res.data.msg){
          this.$message({
            type:"error",
            message:res.data.msg
          });
        }
      }else if(res.status===401){
            this.$message({message: '登录超时，请重新登录',type:"error"});
            await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
            this.$router.replace({
                path: '/main/home',
                query: {redirect: this.$router.currentRoute.fullPath}
            });
      }else if(res.data.code===0){
            this.$message({message:"您的账号在其他地点登陆了！",showClose:true,type:'warning'});
            await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
            this.$router.replace({
                path: '/main/home',
                query: {redirect: this.$router.currentRoute.fullPath}
            });
      }else if(res.status===409||res.status===410||res.status===411){
            this.$message({message:"您的账号在其他地点登陆了！",showClose:true,type:'warning'});
            await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
            this.$router.replace({
                path: '/main/home',
                query: {redirect: this.$router.currentRoute.fullPath}
            });
      }
    },
    // 打开某个模拟志愿表
    openMnzyb(row){
      const id=row.id;
      const pc=row.pc;
      // this.$router.replace("/main/yshMe/collectZyzSchool?id="+id+"pc="+pc);
      const url=this.$router.resolve({
        path:'/main/yshMe/collectZyzSchool',
        query:{id,pc}
      });
      window.open(url.href,"_blank");
    },
    // 通过id删除模拟志愿表内容
    async delMnzybById(id){
      const resBox=await this.getMessageBoxMsg();
      if(resBox=='confirm'){
        const idList=[];
        idList.push(id);
        const res=await this.$http.postHttp("/delMnzyById",idList);
        console.log(res);
        if(res.data.code==200){
          if(res.data.msg){
            this.$message({
              message:res.data.msg,
              type:"success",
              showClose:true
            });
          }else{
            this.$message({
              message:"删除成功",
              type:"success",
              showClose:true
            });
          }
          await this.getMnzybList();
        }else if(res.data.code==500){
          if(res.data.message){
            this.$message({
              type:"error",
              message:res.data.message
            });
          }else if(res.data.msg){
            this.$message({
              type:"error",
              message:res.data.msg
            });
          }
        }else if(res.status===401){
              this.$message({message: '登录超时，请重新登录',type:"error"});
              await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
              this.$router.replace({
                  path: '/main/home',
                  query: {redirect: this.$router.currentRoute.fullPath}
              });
        }else if(res.data.code===0){
              this.$message({message:"您的账号在其他地点登陆了！",showClose:true,type:'warning'});
              await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
              this.$router.replace({
                  path: '/main/home',
                  query: {redirect: this.$router.currentRoute.fullPath}
              });
        }else if(res.status===409||res.status===410||res.status===411){
              this.$message({message:"您的账号在其他地点登陆了！",showClose:true,type:'warning'});
              await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
              this.$router.replace({
                  path: '/main/home',
                  query: {redirect: this.$router.currentRoute.fullPath}
              });
        }
      }else{
        this.$message({
          message:'您取消了操作',
          type:'warning'
        });
      }

    },
    // 获取弹窗返回值
    async getMessageBoxMsg(message='此操作将永久删除该方案, 是否继续?'){
    // center: false
      return new Promise((resolve,reject)=>{
        MessageBox.confirm(message, '提示',{
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        }).then((res) => {
          resolve(res);
        }).catch((res) => {
          resolve(res);
        });
      });
    },
    // 方案多选框删除
    planCheckChange(){
        this.$forceUpdate();
    },
    // 全选方案
    allDialogChecked(){
      const planList=[...this.planList];
      for(let i=0;i<planList.length;i++){
        if(planList[i]){
          planList[i].checked=true;
        }
      }
      this.planList=planList;
    },
    // 取消全选方案
    allDialogNoChecked(){
      const planList=[...this.planList];
      for(let i=0;i<planList.length;i++){
        if(planList[i]){
          planList[i].checked=false;
        }
      }
      this.planList=planList;
    },
    // 删除选中的方案
    async deleteDialogChecked(){
      const resBox=await this.getMessageBoxMsg('您确定要删除这些方案吗？');
      if(resBox=='confirm'){
        const planList=[...this.planList];
        const idList=[];
        for(let i=0;i<planList.length;i++){
          if(planList[i]&&planList[i].checked){
            idList.push(planList[i].id);
          }
        }
        const res=await this.$http.postHttp("/delMnzyById",idList);
        console.log(res);
        if(res.data.code==200){
          if(res.data.msg){
            this.$message({
              message:res.data.msg,
              type:"success",
              showClose:true
            });
          }else{
            this.$message({
              message:"删除成功",
              type:"success",
              showClose:true
            });
          }
          await this.getMnzybList();
        }else if(res.data.code==500){
          if(res.data.message){
            this.$message({
              type:"error",
              message:res.data.message
            });
          }else if(res.data.msg){
            this.$message({
              type:"error",
              message:res.data.msg
            });
          }
        }else if(res.status===401){
              this.$message({message: '登录超时，请重新登录',type:"error"});
              await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
              this.$router.replace({
                  path: '/main/home',
                  query: {redirect: this.$router.currentRoute.fullPath}
              });
        }else if(res.data.code===0){
              this.$message({message:"您的账号在其他地点登陆了！",showClose:true,type:'warning'});
              await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
              this.$router.replace({
                  path: '/main/home',
                  query: {redirect: this.$router.currentRoute.fullPath}
              });
        }else if(res.status===409||res.status===410||res.status===411){
              this.$message({message:"您的账号在其他地点登陆了！",showClose:true,type:'warning'});
              await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
              this.$router.replace({
                  path: '/main/home',
                  query: {redirect: this.$router.currentRoute.fullPath}
              });
        }
      }else{
        this.$message({
          message:'您取消了操作',
          type:'warning'
        });
      }
    },
    // 获取志愿列表
    async getMnzybList(){
      const yhid=this.userInfo.yhid;
      const lb=this.userInfo.zylb;
      const res=await this.$http.getHttp("/getMnzybList?yhid="+yhid+"&&lb="+lb);
      if(res.data.code==200){
        const data=[...res.data.data];
        for(let i=0;i<data.length;i++){
          if(data[i].name){
            data[i].checked=false;
            data[i].updateTime=data[i].updateTime||data[i].createTime;
          }
        }
        this.planList=data;
      }else if(res.data.code==500){
        if(res.data.message){
          this.$message({
            type:"error",
            message:res.data.message
          });
        }else if(res.data.msg){
          this.$message({
            type:"error",
            message:res.data.msg
          });
        }
      }else if(res.status===401){
            this.$message({message: '登录超时，请重新登录',type:"error"});
            await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
            this.$router.replace({
                path: '/main/home',
                query: {redirect: this.$router.currentRoute.fullPath}
            });
      }else if(res.data.code===0){
            this.$message({message:"您的账号在其他地点登陆了！",showClose:true,type:'warning'});
            await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
            this.$router.replace({
                path: '/main/home',
                query: {redirect: this.$router.currentRoute.fullPath}
            });
      }else if(res.status===409||res.status===410||res.status===411){
            this.$message({message:"您的账号在其他地点登陆了！",showClose:true,type:'warning'});
            await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
            this.$router.replace({
                path: '/main/home',
                query: {redirect: this.$router.currentRoute.fullPath}
            });
      } 
    },
    // 选中数据
    handleSelectionChange(selc) {
      const sum=selc.length;
      this.$message({type:"success",message:"你已经选择了"+(sum)+"所院校",showClose:true});
      this.multipleSelection = selc;
    },
    // 选中数据
    handleSelectionChange2(selc) {
      const sum=selc.length;
      this.$message({type:"success",message:"你已经选择了"+(sum)+"所院校",showClose:true});
      this.multipleSelection2 = selc;
    },
    // 本科提前批跨行
    objectSpanMethod({row, column, rowIndex, columnIndex }){
      if(columnIndex===0||columnIndex===1||columnIndex===2||columnIndex===3
        ||columnIndex===4||columnIndex===5||columnIndex===10
        ||columnIndex===12
        ||columnIndex===13||columnIndex===14 ||columnIndex===15
      ){
                if(rowIndex%3===0){
                    return{
                        rowspan:3,
                        colspan:1
                    };
                }else {
                    return {
                        rowspan:0,
                        colspan:0
                    };
                }
      }
    },
    // 高职高专批跨行
    objectSpanMethod2({row, column, rowIndex, columnIndex }){
      if(columnIndex===0||columnIndex===1||columnIndex===2||columnIndex===3
        ||columnIndex===4||columnIndex===5||columnIndex===10
        ||columnIndex===12
        ||columnIndex===13||columnIndex===14 ||columnIndex===15
      ){
                if(rowIndex%3===0){
                    return{
                        rowspan:3,
                        colspan:1
                    };
                }else {
                    return {
                        rowspan:0,
                        colspan:0
                    };
                }
      }
    },
    clickShowInputSbPopover(){},
    changeTabSb(){},
    setSbNoSave(){},
    // 生成院校对比表
    async getCompareData() {
      let checkedList = this.multipleSelection;
      if (checkedList.length === 0) {
        this.$notify({
          title: "提示",
          message: "请先选择要对比的学校！",
          duration: 3000,
          type: "warning",
          offset: 200
        });
        return;
      }
      // if(checkedList.length>45){
      //   this.$message({type:'warning',message:"你选择的院校已经超过了45所，请重新选择45所院校"});
      //   return;
      // }
      let tempArr = [];
      checkedList.map(item => {
        tempArr.push({ gbdm: item.gb, sb: item.sb, yxmc: item.yxmc,zyz:item.zyz });
      });
      let flag=false;
      for(let i=0;i<checkedList.length;i++){
        if(checkedList[i].zylb!==this.userInfo.zylb){
          flag=true;
          break;
        }
      }
      if(flag){
        this.$message({
          message:"选择院校专业组和当前的专业类别不匹配",
          type:"warning",
          showClose:true
        });
        return;
      }
      console.log(tempArr);
      // const result = await this.module.createCompareData(tempArr);
      const result=await this.$http.postHttp("/yxZyzDdb",tempArr);
      console.log(result);
      if (result.data.code === 200) {
        console.log(result.data.data.data);
        this.colleges = result.data.data.data || [];
        if(this.collegesTabName.indexOf(new Date().getFullYear())==-1){
          this.collegesTabName=new Date().getFullYear()+this.collegesTabName;
        }
        this.dialogTableVisible = true;
      }else if(result.data.code===500){
            if(result.data.message){
                this.$message({message:result.data.message,type:'error'});
            }else if(result.data.msg){
              this.$message({message:result.data.msg,type:'error'});
            }
      }else if(result.status===401){
            this.$message({message: '登录超时，请重新登录',type:"error"});
            await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
            this.$router.replace({
                path: '/main/home',
                query: {redirect: this.$router.currentRoute.fullPath}
            });
      }else if(result.data.code===0){
            this.$message({message:"您的账号在其他地点登陆了！",showClose:true,type:'warning'});
            await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
            this.$router.replace({
                path: '/main/home',
                query: {redirect: this.$router.currentRoute.fullPath}
            });
      }else if(result.status===409||result.status===410||result.status===411){
            this.$message({message:"您的账号在其他地点登陆了！",showClose:true,type:'warning'});
            await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
            this.$router.replace({
                path: '/main/home',
                query: {redirect: this.$router.currentRoute.fullPath}
            });
      } 
    },
    // 生成模拟志愿表（用户预览）
    async getCompareData2(){
      let checkedCount=0;
      const checkedList=this.tabPc==0?this.multipleSelection:this.multipleSelection2;
      if (checkedList.length=== 0) {
          this.$notify({
            title: "提示",
            message: "请先选择要下载的模拟志愿表学校！",
            duration: 3000,
            type: "warning",
            offset: 200
          });
        return;
      }
      let listLbFlag=true;
      for(let i=0;i<checkedList.length;i++){
        console.log(checkedList[i].zylb,this.userInfo.zylb);
        if(checkedList[i].lb&&checkedList[i].lb!=this.userInfo.zylb
        ||checkedList[i].zylb&&checkedList[i].zylb!=this.userInfo.zylb){
          listLbFlag=false;
          break;
        }
      }
      if(!listLbFlag){
        this.$message({
          message:'选择院校专业组和当前的专业类别不匹配',
          type:'warning',
          showClose:true
        });
        return;
      }
      // 去除重复的院校
      const checkedList2=[];
      for(let i=0;i<checkedList.length;i++){
        if(checkedList[i]&&checkedList[i].yxmc){
          const haveFlag=checkedList2.find(item=>{
            return checkedList[i]&&item.yxmc==checkedList[i].yxmc
            &&item.zyz==checkedList[i].zyz;
          });
          if(!haveFlag){
            checkedList2.push(checkedList[i]);
          }
        }
      }
      let count=1;
      for(let i=0;i<checkedList.length;i++){
        if(checkedList[i]&&checkedList[i].yxmc){
          checkedList[i].tdxList=[];
          checkedList[i].sffc=1;
          if(i%3==0){
             checkedList[i].xh=count;
             count++;
          }
        }
      }
      const arr2=this.groupSchoolList(checkedList);
      for(let i=0;i<checkedList.length;i++){
        for(let j=0;j<arr2.length;j++){
          if(checkedList[i].yxmc==arr2[j].yxmc
          &&checkedList[i].zyz==arr2[j].zyz){
            checkedList[i].tdxList=arr2[j].tdxList;
          }
        }
      }
      this.colleges=checkedList;
      console.log(checkedList2);
      const pc=this.tabPc;
      let pcName='';
      if(pc=='0'){
        pcName='本科提前批';
      }else if(pc=='7'){
        pcName='高职专科批';
      }
      this.dialogTableVisible=true;
      if(this.collegesTabName.indexOf(new Date().getFullYear())==-1||this.dqTitlePc!=pc){
          if(this.dqTitlePc!=pc){
            this.collegesTabName=this.collegesTabName.replaceAll(/\(本科提前批\)|\(高职专科批\)/g,'')
          }
          this.collegesTabName=new Date().getFullYear()
          +this.collegesTabName+'('+pcName+')';
          if(pc=='0'){
            this.dqTitlePc=0;
          }else if(pc=='7'){
            this.dqTitlePc=7;
          }
      }
    },
    groupSchoolList(checkedList) {
      const map = new Map()
      checkedList.forEach(item => {
        console.log(item);
        // 院校名称作为key
        const key = item.yxmc+' '+item.zyz;
        if (map.has(key)) {
          // 已有该院校，往子数组追加当年数据
          map.get(key).tdxList.push({
            nd: item.nd,
            lowestScore: item.lowestScore
          })
        } else {
          // 首次出现，新建院校对象
          map.set(key, {
            yxmc: item.yxmc,
            zyz:item.zyz,
            tdxList: [
              { nd: item.nd, lowestScore: item.lowestScore }
            ]
          })
        }
      })
      // map转数组返回
      return Array.from(map.values())
    },
    // 降序
    sortData2(){
      const yxs=[...this.colleges];
      const arr1=[];
      for(let i=0;i<yxs.length;i++){
        console.log(!(arr1.length)&&yxs[i].yxmc&&yxs[i].nd==((new Date().getFullYear()-1)+''));
        if(!(arr1.length)&&yxs[i].yxmc&&yxs[i].nd==(new Date().getFullYear()-1)+''){
          arr1.push(yxs[i]);
        }
        for(let j=0;j<arr1.length;j++){
          const yxObj=arr1.find(item=>{
            return item.yxmc==yxs[i].yxmc&&item.zyz==yxs[i].zyz;
          });
          if((arr1[j].yxmc!=yxs[i].yxmc||arr1[j].zyz!=yxs[i].zyz)&&
          yxs[i].nd==((new Date().getFullYear()-1)+'')&&!yxObj){
            arr1.push(yxs[i]);
          }
        }
      }
      for(let i=0;i<arr1.length;i++){
        for(let j=0;j<arr1.length-i-1;j++){
          if(arr1[j].lowestScore<arr1[j+1].lowestScore){
            let temp=arr1[j];
            arr1[j]=arr1[j+1];
            arr1[j+1]=temp;
          }
        }
      }
      // 0-1 1-3 2-6 3-9 4-12
      const arr2=[];
      for(let i=0;i<yxs.length;i++){
        for(let j=0;j<arr1.length;j++){
          if(arr1[j].yxmc==yxs[i].yxmc&&arr1[j].zyz==yxs[i].zyz){
            if(j==0){
              if(yxs[i].nd=='2025'){
                arr2[j]={...yxs[i]};
                arr2[j].xh=j+1;
              }else if(yxs[i].nd=='2024'){
                arr2[j+1]={...yxs[i]};
                arr2[j+1].xh=j+1;
              }else if(yxs[i].nd=='2023'){
                arr2[j+2]={...yxs[i]};
                arr2[j+2].xh=j+1;
              }
            }else if(j>=1){
              if(yxs[i].nd=='2025'){
                arr2[j*3]={...yxs[i]};
                arr2[j*3].xh=j+1;
              }else if(yxs[i].nd=='2024'){
                arr2[j*3+1]={...yxs[i]};
                arr2[j*3+1].xh=j+1;
              }else if(yxs[i].nd=='2023'){
                arr2[j*3+2]={...yxs[i]};
                arr2[j*3+2].xh=j+1;
              }
            }
          }
        }
      }
      this.colleges=arr2;
    },
    // 升序
    sortData3(){
      const yxs=[...this.colleges];
      const arr1=[];
      for(let i=0;i<yxs.length;i++){
        console.log(!(arr1.length)&&yxs[i].yxmc&&yxs[i].nd==((new Date().getFullYear()-1)+''));
        if(!(arr1.length)&&yxs[i].yxmc&&yxs[i].nd==(new Date().getFullYear()-1)+''){
          arr1.push(yxs[i]);
        }
        for(let j=0;j<arr1.length;j++){
          const yxObj=arr1.find(item=>{
            return item.yxmc==yxs[i].yxmc&&item.zyz==yxs[i].zyz;
          });
          if((arr1[j].yxmc!=yxs[i].yxmc||arr1[j].zyz!=yxs[i].zyz)&&
          yxs[i].nd==((new Date().getFullYear()-1)+'')&&!yxObj){
            arr1.push(yxs[i]);
          }
        }
      }
      for(let i=0;i<arr1.length;i++){
        for(let j=0;j<arr1.length-i-1;j++){
          if(arr1[j].lowestScore>arr1[j+1].lowestScore){
            let temp=arr1[j];
            arr1[j]=arr1[j+1];
            arr1[j+1]=temp;
          }
        }
      }
      // 0-1 1-3 2-6 3-9 4-12
      const arr2=[];
      for(let i=0;i<yxs.length;i++){
        for(let j=0;j<arr1.length;j++){
          if(arr1[j].yxmc==yxs[i].yxmc&&arr1[j].zyz==yxs[i].zyz){
            if(j==0){
              if(yxs[i].nd=='2025'){
                arr2[j]={...yxs[i]};
                arr2[j].xh=j+1;
              }else if(yxs[i].nd=='2024'){
                arr2[j+1]={...yxs[i]};
                arr2[j+1].xh=j+1;
              }else if(yxs[i].nd=='2023'){
                arr2[j+2]={...yxs[i]};
                arr2[j+2].xh=j+1;
              }
            }else if(j>=1){
              if(yxs[i].nd=='2025'){
                arr2[j*3]={...yxs[i]};
                arr2[j*3].xh=j+1;
              }else if(yxs[i].nd=='2024'){
                arr2[j*3+1]={...yxs[i]};
                arr2[j*3+1].xh=j+1;
              }else if(yxs[i].nd=='2023'){
                arr2[j*3+2]={...yxs[i]};
                arr2[j*3+2].xh=j+1;
              }
            }
          }
        }
      }
      this.colleges=arr2;
    },
    // 下载模拟志愿表
    async download2(){
      /* 
      文件属于流文件不是json,所以要改响应类型responseType为arraybuffer而不是改header.
      拿到二进制文件还需要按照服务器响应头的数据类型转换.
      */
      const yxs = [...this.colleges];
      console.log(yxs);
      // axios({
      //   method: "POST",
      //   url: "/api/download",
      //   data: yxs,
      //   responseType: "arraybuffer"
      // }).then(res => {
      //   this.exportExcel(res);
      // });
      for(let i=0;i<yxs.length;i++){
        if(yxs[i].yxmc){
          yxs[i].lb=yxs[i].zylb||yxs[i].lb;
          yxs[i].sffc='服从';
          yxs[i].xh=i+1;
          yxs[i].zy1=yxs[i].zydh1;
          yxs[i].zy2=yxs[i].zydh2;
          yxs[i].zy3=yxs[i].zydh3;
          yxs[i].zy4=yxs[i].zydh4;
          yxs[i].zy5=yxs[i].zydh5;
          yxs[i].zy6=yxs[i].zydh6;
          yxs[i].gbdm=yxs[i].gb||yxs[i].gbdm||yxs[i].collegeid;
        }
      }
      console.log(this.$http);
      const obj={};
      obj.bz=this.userInfo.bz;
      obj.ghs='';
      obj.whcj=this.userInfo.gkfs;
      obj.zycj=this.userInfo.zscore;
      obj.jf=this.userInfo.yfjf;
      obj.list=yxs;
      obj.pc=yxs[0].pc;
      obj.shu=this.userInfo.sxcj||null;
      obj.sjhm=this.userInfo.sjhm;
      obj.sxkm=this.userInfo.sxkm;
      obj.sxkmfs=this.userInfo.sxkmcj||null;
      obj.wai=this.userInfo.wycj||null;
      obj.xb=this.userInfo.xb;
      obj.xm=this.userInfo.xm;
      obj.yu=this.userInfo.ywcj||null;
      obj.zhf=this.userInfo.equivalent;
      obj.zxkma=this.userInfo.zxkma;
      obj.zxkmafs=this.userInfo.zxkmacj||null;
      obj.zxkmb=this.userInfo.zxkmb;
      obj.zxkmbfs=this.userInfo.zxkmbcj||null;
      obj.lb=this.userInfo.zylb||null;
      const flag=this.$apiFlag;
      const loading=this.$loading({target:document.getElementById("yxsTab"),fullScreen:true,
        text:'正在下载中'
      });
      if(flag===1||flag===3){
        axios({
          method: "POST",
          url: "/api/down/downArtMnzyb",
          data: obj,
          responseType: "arraybuffer"
        }).then(async (res) => {
          await this.downloadSavePlan(yxs);
          this.exportExcel(res);
        });
      }else if(flag===2){
        axios({
          method: "POST",
          url: "/down/downArtMnzyb",
          data: obj,
          responseType: "arraybuffer"
        }).then(async (res2) => {
          await this.downloadSavePlan(yxs);
          this.exportExcel(res2);
        });
      }
      loading.close();
    },
    async downloadSavePlan(yxs){
          const pc=this.tabPc;
          const obj={};
          let saveYxs=[];
          for(let i=0;i<yxs.length;i++){
            if(yxs[i].yxmc){
              yxs[i].collegeid=yxs[i].gb||yxs[i].gbdm;
              yxs[i].uid=this.userInfo.yhid;
              yxs[i].szdq=yxs[i].yxdq||yxs[i].szdq;
              // Yxs[i].yhid=this.userInfo.yhid;
              yxs[i].lb=yxs[i].zylb;
            }
            const haveFlag=saveYxs.find(item=>{
              return yxs[i]&&item.yxmc==yxs[i].yxmc&&item.zyz==yxs[i].zyz;
            });
            if(!haveFlag){
              saveYxs.push(yxs[i]);
            }
          }
          obj.list=saveYxs;
          obj.lb=this.userInfo.zylb;
          obj.yhid=this.userInfo.yhid;
          obj.name=(this.userInfo.xm||'')+''+(new Date().getTime());
          obj.mnzybId=0;
          obj.pc=parseInt(pc);
          const res=await this.$http.postHttp("/saveMnzyb",obj);
          if(res.data.code==200){

          }else if(res.data.code===500){
            if(res.data.message){
                this.$message({message:res.data.message,type:'error'});
            }else if(res.data.msg){
              this.$message({message:res.data.msg,type:'error'});
            }
          }else if(res.status===401){
                this.$message({message: '登录超时，请重新登录',type:"error"});
                await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
                this.$router.replace({
                    path: '/main/home',
                    query: {redirect: this.$router.currentRoute.fullPath}
                });
          }else if(res.data.code===0){
                this.$message({message:"您的账号在其他地点登陆了！",showClose:true,type:'warning'});
                await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
                this.$router.replace({
                    path: '/main/home',
                    query: {redirect: this.$router.currentRoute.fullPath}
                });
          }else if(res.status===409||res.status===410||res.status===411){
                this.$message({message:"您的账号在其他地点登陆了！",showClose:true,type:'warning'});
                await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
                this.$router.replace({
                    path: '/main/home',
                    query: {redirect: this.$router.currentRoute.fullPath}
                });
          }
    },
    // 排序处理
    sortData() {
      let sortColleges = [...this.colleges];
      for (let i = 0; i < sortColleges.length; i++) {
        for (let j = 0; j < sortColleges.length - 1 - i; j++) {
          if (
            sortColleges[j].tdx[0].tdx * 1 >
            sortColleges[j + 1].tdx[0].tdx * 1
          ) {
            let temp = sortColleges[j];
            sortColleges[j] = sortColleges[j + 1];
            sortColleges[j + 1] = temp;
          }
        }
      }
      this.colleges = sortColleges;
    },
    // 下载数据
    async download() {
      /* 
      文件属于流文件不是json,所以要改响应类型responseType为arraybuffer而不是改header.
      拿到二进制文件还需要按照服务器响应头的数据类型转换.
      */
      const yxs = [...this.colleges];
      for(let i=0;i<yxs.length;i++){
        if(this.colleges[i].tdx[0].pc==="0"){
          yxs[i].tdx[0].pc="本科提前批";
        }else if(this.colleges[i].tdx[0].pc==="8"){
          yxs[i].tdx[0].pc="专科提前批";
        }else if(this.colleges[i].tdx[0].pc===6){
          yxs[i].tdx[0].pc="本科批";
        }else if(this.colleges[i].tdx[0].pc===7){
          // yxs[i].tdx[0].pc="高职专科批";
        }else if(this.colleges[i].tdx[0].pc===0){
          // yxs[i].tdx[0].pc="本科提前批";
        }else if(this.colleges[i].tdx[0].pc===8){
          // yxs[i].tdx[0].pc="专科提前批";
        }
        if(this.colleges[i].tdx[0].kl==="1"){
          yxs[i].tdx[0].kl="历史"
        }else if(this.colleges[i].tdx[0].kl==="2"){
          yxs[i].tdx[0].kl="物理"
        }else if(this.colleges[i].tdx[0].kl===1){
          // yxs[i].tdx[0].kl="历史";
        }else if(this.colleges[i].tdx[0].kl===2){
          // yxs[i].tdx[0].kl="物理";
        }
        // yxs[i].sxkm=this.userInfo.sxkm;
      }
      console.log(yxs);
      // axios({
      //   method: "POST",
      //   url: "/api/download",
      //   data: yxs,
      //   responseType: "arraybuffer"
      // }).then(res => {
      //   this.exportExcel(res);
      // });
      console.log(this.$http);
      const flag=this.$apiFlag;
      if(flag===1||flag===3){
        axios({
          method: "POST",
          url: "/api/download",
          data: yxs,
          responseType: "arraybuffer"
        }).then(res => {
          this.exportExcel(res);
        });
      }else if(flag===2){
        axios({
          method: "POST",
          url: "/download",
          data: yxs,
          responseType: "arraybuffer"
        }).then(res => {
          this.exportExcel(res);
        });
      }
    },
    // 选择专业
    async chooseZy(row){
      await this.getZyListByParam(row);
      this.dialogZyChooseVisible=true;
    },
    // 关闭选择专业框
    closeZyDialog(){
      this.dialogZyChooseVisible=false;
    },
    // 保存某一行选择的专业
    async saveCheckedZy(){
      const pc=this.tabPc;
      if(this.selectedZys.length===0){
            this.$message({message:'请选择好专业',type:'warning',showClose:true});
            return;
      }
      const yxTabList=pc=='0'?this.collectSchool.bkZyzRecords:
      this.collectSchool.zkZyzRecords;
      let yxObj={};
      let dqIndex=-1;
      for(let i=0;i<yxTabList.length;i++){
        if(yxTabList[i].yxmc==this.searchYxmc
        &&yxTabList[i].zyz==this.searchZyz){
          yxObj={...yxTabList[i]};
          dqIndex=i;
          break;
        }
      }
      const zys=this.selectedZys;
      const zyData=[...this.zyData];
      for(let i=1;i<7;i++){
          yxObj['zydh'+i]=null;
      }
      for(let i=0;i<zys.length;i++){
          if(zys[i]&&i<=5){
            yxObj['zydh'+(i+1)]=zys[i];
            // for(let j<=0;j<zyData.length;j++){
            //   if(zyData[j].zydh==zys[i]){
            //     yxObj['zymc'+(i+1)]=zyData[i].zymc;
            //     yxObj['sf'+(i+1)]=zyData[i].sf;
            //   }
            // }
          }
        }
      if(pc=='0'){
        this.$set(this.collectSchool.bkZyzRecords,dqIndex,yxObj);
        this.$set(this.collectSchool.bkZyzRecords[dqIndex],'chooseFlag',true);
        console.log(this.collectSchool.bkZyzRecords[dqIndex]);
      }else{
        this.$set(this.collectSchool.zkZyzRecords,dqIndex,yxObj);
        this.$set(this.collectSchool.zkZyzRecords[dqIndex],'chooseFlag',true);
      }
      if(this.planObj.plan){
        const obj={...yxObj};
        obj.collegeid=yxObj.gb||yxObj.gbdm||yxObj.collegeid;
        obj.gbdm=yxObj.gb||yxObj.gbdm||yxObj.collegeid;
        obj.id=yxObj.id;
        obj.lb=yxObj.lb||yxObj.zylb;
        obj.pc=yxObj.pc;
        obj.sb=yxObj.sb||yxObj.yxdm;
        obj.szdq=yxObj.szdq||obj.yxdq;
        obj.uid=this.userInfo.yhid;
        const res=await this.$http.postHttp("/updateMnzyDetail",obj);
        console.log(res);
        if(res.data.code==200){

        }else if(result.data.code===500){
              if(result.data.message){
                  this.$message({message:result.data.message,type:'error'});
              }else if(result.data.msg){
                this.$message({message:result.data.msg,type:'error'});
              }
        }else if(result.status===401){
              this.$message({message: '登录超时，请重新登录',type:"error"});
              await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
              this.$router.replace({
                  path: '/main/home',
                  query: {redirect: this.$router.currentRoute.fullPath}
              });
        }else if(result.data.code===0){
              this.$message({message:"您的账号在其他地点登陆了！",showClose:true,type:'warning'});
              await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
              this.$router.replace({
                  path: '/main/home',
                  query: {redirect: this.$router.currentRoute.fullPath}
              });
        }else if(result.status===409||result.status===410||result.status===411){
              this.$message({message:"您的账号在其他地点登陆了！",showClose:true,type:'warning'});
              await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
              this.$router.replace({
                  path: '/main/home',
                  query: {redirect: this.$router.currentRoute.fullPath}
              });
        }
      }else{
        const obj={...yxObj};
        obj.collegeid=yxObj.gb||yxObj.gbdm||yxObj.collegeid;
        obj.gbdm=yxObj.gb||yxObj.gbdm||yxObj.collegeid;
        obj.id=yxObj.id;
        obj.lb=yxObj.lb||yxObj.zylb;
        obj.pc=yxObj.pc;
        obj.sb=yxObj.sb||yxObj.yxdm;
        obj.szdq=yxObj.szdq||obj.yxdq;
        obj.uid=this.userInfo.yhid;
        console.log(obj);
        const res=await this.$http.postHttp("/updateYhgzYxZyz",obj);
        if(res.data.code==200){

        }else if(res.data.code===500){
              if(res.data.message){
                  this.$message({message:res.data.message,type:'error'});
              }else if(res.data.msg){
                this.$message({message:res.data.msg,type:'error'});
              }
        }else if(res.status===401){
              this.$message({message: '登录超时，请重新登录',type:"error"});
              await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
              this.$router.replace({
                  path: '/main/home',
                  query: {redirect: this.$router.currentRoute.fullPath}
              });
        }else if(res.data.code===0){
              this.$message({message:"您的账号在其他地点登陆了！",showClose:true,type:'warning'});
              await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
              this.$router.replace({
                  path: '/main/home',
                  query: {redirect: this.$router.currentRoute.fullPath}
              });
        }else if(res.status===409||res.status===410||res.status===411){
              this.$message({message:"您的账号在其他地点登陆了！",showClose:true,type:'warning'});
              await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
              this.$router.replace({
                  path: '/main/home',
                  query: {redirect: this.$router.currentRoute.fullPath}
              });
        }
      }
      this.dialogZyChooseVisible=false;
      this.$store.commit("setYsCollectPc",{pc:pc});
      if(pc==0){
        this.$store.commit("setYsCollectPageNum",{
          pageNum:this.collectSchool.bkPageNum});
      }else{
        this.$store.commit("setYsCollectPageNum",{
          pageNum:this.collectSchool.zkPageNum});
      }
        const { pc:pc2 ,id:id2}= this.$route.query;
        if(pc2>=0&&id2){
          // this.$router.push({
          //   path:'/main/yshMe/collectZyzSchool',
          //   query:{
          //     pc2,
          //     id2,
          //     time:new Date().getTime()}
          // });
          // location.reload();
        }else{
          this.$router.push({
            path:'/main/yshMe/collectZyzSchool',
            query:{
              time:new Date().getTime()
            }
          });
          location.reload();
        }
    },
    // 通过国标、专业组、批次查询所有专业
    async getZyListByParam(row){
      const gb=row.gb||row.gbdm||row.collegeid;
      const zyz=row.zyz;
      const yxmc=row.yxmc;
      const pc=row.pc;
      const zydhs=[];
      let yxObj={};
      this.searchYxmc=yxmc;
      this.searchZyz=zyz;
      const yxTabList=this.tabPc=='0'?this.collectSchool.bkZyzRecords:
      this.collectSchool.zkZyzRecords;
      for(let i=0;i<yxTabList.length;i++){
        if(yxTabList[i]&&yxTabList[i].yxmc==row.yxmc
        &&yxTabList[i].zyz==row.zyz){
          yxObj={...yxTabList[i]};
        }
      }
      for(let i=1;i<7;i++){
        if(yxObj['zydh'+i]){
          zydhs.push(yxObj['zydh'+i]);
        }
      }
      this.selectedZys=zydhs;
      const res=await this.$http.getHttp("/querySchoolDetailed/"+gb+'/'+zyz+'/'+pc);
      // const res=await this.$http.getHttp("querySchoolDetailed/"+gb+'/'+zyz);
      console.log(res);
      if(res.data.code==200){
        const dataObj={...res.data.data};
        const data=[...dataObj.zyList];
        const zys=[];
        for(let i=0;i<data.length;i++){
          zys.push({
            key:data[i].zydh,
            title:data[i].zydh+' '+data[i].zymc,
            description:'',
            xf:'￥'+data[i].xf+'/年',
            xh:0,
            isDisabled:false,
            isChecked:false
          });
        }
        for(let i=0;i<zys.length;i++){
          for(let j=0;j<zydhs.length;j++){
               if(zys[i].key===zydhs[j]){
                  zys[i].xh=j+1;
                }
           }
        }
                const arr=[];
                for(let i=0;i<zys.length;i++){
                    if(zys[i].xh>0){
                        arr[zys[i].xh-1]=zys[i];
                    }
                }
                const leftRemanentArr=zys.filter((item,index)=>{
                    let flag=true;
                    for(let i=0;i<zydhs.length;i++){
                        if(item.key===zydhs[i]){
                            flag=false;
                            break;
                        }
                    }
                    if(flag){
                        return item;
                    }else{
                        return null;
                    }
                });
                this.filterZyDataLeft=leftRemanentArr.filter(item=>item!==null);
                console.log(arr,zys,this.filterZyDataLeft);
                this.zyData=zys;
                this.filterZyData=arr;
                this.rightShowCount=zydhs.length;
                this.leftSelectRows=[];
                this.rightSelectRows=[];
                this.leftTopTitle=`<span style="color: blue;font-weight: 700;">${row.yxmc}</span>
                ${zyz}组共${yxTabList.length}个专业`;
                this.rightTopTitle=`已选择
                <span style="color: blue;font-weight: 700;">${ this.selectedZys.length }</span>个专业填报`;
      }else if(res.data.code===500){
            if(res.data.message){
                this.$message({message:res.data.message,type:'error'});
            }else if(res.data.msg){
              this.$message({message:res.data.msg,type:'error'});
            }
      }else if(res.status===401){
            this.$message({message: '登录超时，请重新登录',type:"error"});
            await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
            this.$router.replace({
                path: '/main/home',
                query: {redirect: this.$router.currentRoute.fullPath}
            });
      }else if(res.data.code===0){
            this.$message({message:"您的账号在其他地点登陆了！",showClose:true,type:'warning'});
            await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
            this.$router.replace({
                path: '/main/home',
                query: {redirect: this.$router.currentRoute.fullPath}
            });
      }else if(res.status===409||res.status===410||res.status===411){
            this.$message({message:"您的账号在其他地点登陆了！",showClose:true,type:'warning'});
            await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
            this.$router.replace({
                path: '/main/home',
                query: {redirect: this.$router.currentRoute.fullPath}
            });
      }
    },
    openChooseZy(){},
    aTabRowClassName(record, index){
        if(record.isDisabled){
            return 'disabled-row';
        }
    },
    // 左边选择框变化
    leftTabChange(pagination, filters, sorter, { currentDataSource }){
        console.log(pagination, filters, sorter, { currentDataSource });
    },
    // you
    rightTabChange(pagination, filters, sorter, { currentDataSource }){
        console.log(pagination, filters, sorter, { currentDataSource });
    },
    // 专业往左移动
    addLeftZy(){
        const targetKeys=[];
        this.filterZyData.forEach((item,index)=>{
            const len=this.rightSelectRows.length;
            const rightCheckedArr=[...this.rightSelectRows];
            let haveFlag=false;
            for(let i=0;i<len;i++){
                if(rightCheckedArr[i]===item.key){
                    haveFlag=true;
                    break;
                }
            }
            if(!haveFlag){
                targetKeys.push(item.key);
            }
        });
        console.log(targetKeys);
         if((targetKeys.length<=6)){
            const zyData=[...this.zyData];
            // 选择的专业数量 0 1 2 3 4 5
            let selectZyCount=this.rightShowCount;
            console.log(selectZyCount);
            // 剩余专业数量
            // 
            let remanentCount=6-selectZyCount;
            let addtiveCount=1;
            if(remanentCount<=6){
                for(let i=0;i<zyData.length;i++){
                    if(zyData[i]&&zyData[i].title){
                        zyData[i].xh=0;
                    }
                }
                for(let i=0;i<zyData.length;i++){
                    for(let j=0;j<targetKeys.length;j++){
                        if(zyData[i].key===targetKeys[j]){
                            zyData[i].xh=j+1;
                        }
                    }
                }
            }
            this.selectedZys = targetKeys;
            this.rightSelectRows=[];
            this.filterZyData=this.filterZyData.filter(item=>{
                return item.xh>0;
            });
            this.filterZyDataLeft=this.zyData.filter(item=>{
                return item.xh===0;
            });
            return;
        }
    },
    // 专业往右移动
    addRightZy(){
        const targetKeys=[...this.selectedZys,...this.leftSelectRows];
        const moveKeys=[...this.leftSelectRows];
        if((targetKeys.length>6)){
            const selectedZys=[...this.selectedZys];
            if(selectedZys.length<6){
                const msgCount=6-selectedZys.length;
                this.$message({message:'还能选择'+msgCount+'个专业',type:'warning',showClose:true});
                const outLen=targetKeys.length;
                const inLen=moveKeys.length;
                const arr=[];
                for(let i=0;i<outLen;i++){
                    let haveFlag=false;
                    for(let j=0;j<inLen;j++){
                        if(targetKeys[i]===moveKeys[j]){
                            haveFlag=true;
                            break;
                        }
                    }
                    if(!haveFlag){
                        arr.push(targetKeys[i]);
                    }
                }
                this.selectedZys=arr;
            }else{
                this.$message({message:'已经选择了6个专业',type:'warning',showClose:true});
                const outLen=targetKeys.length;
                const inLen=moveKeys.length;
                const arr=[];
                for(let i=0;i<outLen;i++){
                    let haveFlag=false;
                    for(let j=0;j<inLen;j++){
                        if(targetKeys[i]===moveKeys[j]){
                            haveFlag=true;
                            break;
                        }
                    }
                    if(!haveFlag){
                        arr.push(targetKeys[i]);
                    }
                }
                this.selectedZys=arr;
            }
            this.leftSelectRows=[];
            const leftTabData=[...this.filterZyDataLeft];
            for(let i=0;i<leftTabData.length;i++){
                if(leftTabData[i].key){
                    leftTabData[i].isDisabled=false;
                }
            }
            this.filterZyDataLeft=leftTabData;
            console.log("13850 selectedZys=",this.selectedZys);
            return;
        }else if((targetKeys.length<=6)){
            console.log(moveKeys);
            const selectedZys=[...this.selectedZys];
            for(let i=0;i<moveKeys.length;i++){
                selectedZys.push(moveKeys[i]);
            }
            const zyData=[...this.zyData];
            // 选择的专业数量 0 1 2 3 4 5
            let selectZyCount=this.rightShowCount;
            console.log(selectZyCount);
            // 剩余专业数量
            // 
            let remanentCount=6-selectZyCount;
            let addtiveCount=1;
            if(remanentCount<=6){
                for(let i=0;i<zyData.length;i++){
                    if(zyData[i]&&zyData[i].title){
                        zyData[i].xh=0;
                    }
                }
                for(let i=0;i<zyData.length;i++){
                    for(let j=0;j<selectedZys.length;j++){
                        if(zyData[i].key===selectedZys[j]){
                            zyData[i].xh=j+1;
                        }
                    }
                }
            }
            this.selectedZys=selectedZys;
            this.filterZyDataLeft=this.zyData.filter(item=>{
                return item.xh===0;
            });
            this.filterZyDataLeft.forEach(item=>{
                if(item){
                    item.isDisabled=false;
                }
            })
            this.filterZyData=this.zyData.filter(item=>{
                return item.xh>0;
            });
            this.filterZyData.sort((a,b)=>{
                return a.xh-b.xh;
            });
            this.leftSelectRows=[];
            console.log(this.filterZyData);
            return;
        }
    },
    // 专业上移
    moveUp2(){
        const item=[...this.rightSelectRows];
        const selectedZys=[...this.filterZyData];
        const len=item.length;
        if(len>1){
            this.$message({message:'只能移动一个专业',type:'warning',showClose:true});
            return false;
        }
        const zy=item[0];
        let index=-1;
        for(let i=0;i<selectedZys.length;i++){
            if(selectedZys[i].key===zy){
                index=i;
            }
        }
        if(index===-1){
            this.$message({message:'请选择某一个专业',type:'warning',showClose:true});
            return false;
        }
        if(index===0){
            return false;
        }
        const obj=selectedZys[index];
        const prevObj=selectedZys[index-1];
        this.$set(this.filterZyData,index,prevObj);
        this.$set(this.filterZyData,index-1,obj);
        this.filterZyData.forEach((item,index)=>{
            item.xh=index+1;
        });
        this.filterZyData.sort((a,b)=>{
            return a.xh-b.xh;
        });
        const rightArr=[...this.filterZyData];
        const arrSelectedZy=[];
        for(let i=0;i<rightArr.length;i++){
            if(rightArr[i].title){
                arrSelectedZy.push(rightArr[i].key);
            }
        }
        this.selectedZys=arrSelectedZy;
    },
    // 专业下移
    moveDown2(){
        const item=[...this.rightSelectRows];
        const selectedZys=[...this.filterZyData];
        const len=item.length;
        if(len>1){
            this.$message({message:'只能移动一个专业',type:'warning',showClose:true});
            return false;
        }
        const zy=item[0];
        let index=-1;
        for(let i=0;i<selectedZys.length;i++){
            if(selectedZys[i].key===zy){
                index=i;
            }
        }
        if(index===-1){
            this.$message({message:'请选择某一个专业',type:'warning',showClose:true});
            return false;
        }
        if(index===selectedZys.length-1){
            return false;
        }
        const obj=selectedZys[index];
        const nextObj=selectedZys[index+1];
        this.$set(this.filterZyData,index,nextObj);
        this.$set(this.filterZyData,index+1,obj);
        this.filterZyData.forEach((item,index)=>{
            item.xh=index+1;
        });
        this.filterZyData.sort((a,b)=>{
            return a.xh-b.xh;
        });
        const rightArr=[...this.filterZyData];
        const arrSelectedZy=[];
        for(let i=0;i<rightArr.length;i++){
            if(rightArr[i].title){
                arrSelectedZy.push(rightArr[i].key);
            }
        }
        this.selectedZys=arrSelectedZy;
    },
    // 下载
    exportExcel(res) {
      let blob = new Blob([res.data], {
        type: "application/octet-stream;charset=utf-8"
      });
      let link = document.createElement("a");
      link.style.display = "none";
      link.href = URL.createObjectURL(blob); // 创建下载的链接
      link.setAttribute("download", new Date().getTime() + ".xls"); // 给下载后的文件命名
      document.body.appendChild(link);
      link.click(); // 点击下载
      document.body.removeChild(link); //下载完成移除元素
      window.URL.revokeObjectURL(link.href); // 释放掉blob对象
    }
  },
  async mounted() {
    await this.getApiIndexMethod();
    const loading1=this.$loading({fullscreen:true,target:this.$refs.collectSchoolRef1,text:"正在加载中"});
    const {id,pc} =this.$route.query;
    if(id&&pc){
      await this.getMnzybById(id);
      this.tabPc=pc+'';
    }else{
      // await this.$store.dispatch("getCollectSchoolZyz", {
      //   uid: this.userInfo.yhid,
      //   pageNum: this.pageNum
      // });
      console.log(this.ysCollectInfo.pageNum);
      if(this.ysCollectInfo.pageNum){
        this.tabPc=this.ysCollectInfo.pc+'';
        await this.$store.dispatch("getCollectSchoolZyz", {
            uid: this.userInfo.yhid,
            pageNum: this.pageNum,
            pageNum2: this.ysCollectInfo.pageNum,
            pc1:0,
            pc2:7,
            pcStorage:this.ysCollectInfo.pc
        });
      }else{
        await this.$store.dispatch("getCollectSchoolZyz", {
          uid: this.userInfo.yhid,
          pageNum: this.pageNum,
          pc1:0,
          pc2:7
        });
      }
    }
    loading1.close();
  }
};
</script>

<style lang="stylus" scoped>
.collect-school
    margin-left 30px
    width 900px
    min-height calc(100vh - 380px)
    min-height -moz-calc(100vh - 380px)
    min-height -webkit-calc(100vh - 380px)
    background-color #ffffff
    .title
        width 100%
        height 35px
        box-sizing border-box
        padding-left 10px
        line-height 35px
        font-size 15px
        font-weight 600
        color #2F4056
        background-color #D3D3D3
    .collect-panel
        width 95%
        margin 20px auto
        .create-compare
            display flex
            justify-content space-between
            margin-bottom 10px
            text-align right
    .pagination
        padding 20px 0
        text-align center
</style>
<style scoped>
.page-scroll {
  max-height:560px;
  overflow: auto;
  scrollbar-width: thin;
  scrollbar-color: #25A4BB #eeeaea;
}

.page-scroll::-webkit-scrollbar {
  width: 6px;
  height: 3px;
}
.page-scroll::-webkit-scrollbar-track {
  background: #eeeaea;
  border-radius: 3px;
}
.page-scroll::-webkit-scrollbar-thumb {
  background: #25A4BB;
  border-radius: 3px;
}
.page-scroll::-webkit-scrollbar-thumb:hover {
  background: #999;
}
</style>
